<dx-popup
    title="Confirmation"
    [width]="380"
    [height]="260"
    [showTitle]="true"
    [resizeEnabled]="false"
    [(visible)]="visible"
    (onShown)="onShown($event)"
    (onHidden)="onHidden($event)"
>
    <div *dxTemplate="let item of 'content'" class="waive-invoice-content">
        <dx-form
            *ngIf="!!waiveParams"
            #confirmForm
            width="100%"
            height="100%"
            [labelLocation]="formLabelLocation"
            [colCount]="1"
            [(formData)]="waiveParams"
        >
            <dxi-item>
                <div *dxTemplate>Are you sure you want to waive charges on the invoice? Please provide a reason</div>
            </dxi-item>
            <dxi-item
                dataField="waiveReason"
                [isRequired]="true"
                editorType="dxTextArea"
                [editorOptions]="{
                    placeholder: 'Reason for Waiving',
                    minHeight: 100
                }"
            >
                <dxo-label text="Waive Reason"></dxo-label>
                <dxi-validation-rule type="required" message="Waive reason is required"></dxi-validation-rule>
                <dxi-validation-rule
                    type="stringLength"
                    [min]="10"
                    message="Waive reason must have at least 10 characters"
                ></dxi-validation-rule>
            </dxi-item>
            <dxi-item itemType="group" [colCount]="2">
                <dxi-item
                    itemType="button"
                    horizontalAlignment="right"
                    [buttonOptions]="{
                        type: 'success',
                        text: 'Yes',
                        icon: iconCheck,
                        useSubmitBehavior: true,
                        width: 120,
                        onClick: onYesClick
                    }"
                ></dxi-item>
                <dxi-item
                    itemType="button"
                    horizontalAlignment="left"
                    [buttonOptions]="{
                        type: 'default',
                        text: 'Cancel',
                        icon: iconCancel,
                        width: 120,
                        onClick: onCancelClick
                    }"
                ></dxi-item>
            </dxi-item>
        </dx-form>
    </div>
</dx-popup>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: 'body' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>
